// @link https://codepen.io/aaronbushnell/pen/eGVdzv
export default () => {

   
    let items = document.querySelectorAll('.b-foldout-item')

    let box = document.querySelector('.b-foldout-box')
    let boxes = document.querySelectorAll('.b-foldout-box-item')

    let activeBoxItem = null
    let activeTarget = null
    let activeItem = null
    let wrapper = document.querySelector('.b-foldout')



    let closeButtons = document.querySelectorAll('.b-foldout-box-item__close');

    items.forEach( (item, index) => {
        
        item.addEventListener('click', (e) => {

            let target = item.getAttribute('data-foldout-target')               
            let boxItem = boxes[target]

            if ( activeBoxItem != boxItem ) {

                let gridTemplateColumns = window.getComputedStyle(wrapper).gridTemplateColumns.split(" ").length;


                // Remove active class
                if (activeBoxItem) {
                    activeBoxItem.classList.remove('--active')
                    activeItem.classList.remove('--active')
                }

                item.classList.add('--active')
                boxItem.classList.add('--active')
                
                const rowPosition = Math.floor(target / gridTemplateColumns) + 2
                box.setAttribute('style', 'grid-row:' + rowPosition)
                activeBoxItem = boxItem
                activeTarget = target
                activeItem = item

            } else {
                closebox()
            }
        })
    })


    closeButtons.forEach( (button, index) => {
        
        button.addEventListener('click', (e) => {
            closebox()
        })
    })


    function closebox() {
        if (activeBoxItem) {
            activeBoxItem.classList.remove('--active')
            activeItem.classList.remove('--active')
            box.removeAttribute('style')
            activeBoxItem = null
            activeTarget = null
        }
    }


    window.addEventListener('resize', function(event) {
        if (activeBoxItem) {
            let gridTemplateColumns = window.getComputedStyle(wrapper).gridTemplateColumns.split(" ").length;
            const rowPosition = Math.floor(activeTarget / gridTemplateColumns) + 2
            box.setAttribute('style', 'grid-row:' + rowPosition)
        }

    }, true);

}